import React from 'react';
import EasternTime from './datetimeHedaer/dt';
import './header.scss';
import { useState, useEffect} from 'react';
export default function Header({change, children}) {

  const [date, setDate] = useState(null)
  
  function handleClick() {
    window.location.reload();
  }
  function printPage() {
    window.print();
}

  useEffect(() => {

    async function fetchDate() {

    const date = new  Date
    await setDate(date.toLocaleString('en-US', {timeZone: 'America/New_York'}).replace(",","").replace(/:.. /," "))

    }
    fetchDate()


  }, [change])


 
  return (
    <div className='header'>
      <div className='header-brand'>
        <img src='/logoMark_Color.png' alt='Fleet&apos;s Eye logo' />
        <h1>Fleet&apos;s Eye</h1>
      </div>
      <div className='header-tools'>{children}</div>
      <div className='date-box'>
        <span>Last Refreshed</span>
        <strong>{date}</strong>
      </div>
    </div>
  )
}
